import { render, staticRenderFns } from "./UpsettingPage.vue?vue&type=template&id=255f48de&scoped=true&"
import script from "./UpsettingPage.vue?vue&type=script&lang=js&"
export * from "./UpsettingPage.vue?vue&type=script&lang=js&"
import style0 from "./UpsettingPage.vue?vue&type=style&index=0&id=255f48de&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "255f48de",
  null
  
)

export default component.exports